import { render } from "./AppointmentAsPrivate.vue?vue&type=template&id=27925654&scoped=true"
import script from "./AppointmentAsPrivate.vue?vue&type=script&lang=js"
export * from "./AppointmentAsPrivate.vue?vue&type=script&lang=js"

import "./AppointmentAsPrivate.vue?vue&type=style&index=0&id=27925654&scoped=true&lang=css"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27925654"]])

export default __exports__